import { gql } from "@apollo/client";

// Query: Get a specific LibraryCard
export const GET_LIBRARY_CARD_QUERY = gql`
  query GetLibraryCard($input: GetLibraryCardInput!) {
    getLibraryCard(input: $input) {
      startup
      entityType
      entityId
      data
      bucket
      s3Url
      thumbnailUrl
      tags
      createdAt
    }
  }
`;

// Query: Get STARTUPRECORD (and tenantId) by Cognito userId via CreatedByIndex GSI
export const GET_STARTUP_BY_USER_QUERY = gql`
  query GetStartupByUser($input: GetStartupByUserInput!) {
    getStartupByUser(input: $input) {
      tenantId
      startup
      entityType
      entityId
      data
      createdAt
    }
  }
`;

// Query: List LibraryCards for a tenant and entity type
export const LIST_LIBRARY_CARDS_QUERY = gql`
  query ListLibraryCards($input: ListLibraryCardsInput!) {
    listLibraryCards(input: $input) {
      pageNames
    }
  }
`;

// Mutation: Save a LibraryCard
export const SAVE_LIBRARY_CARD_MUTATION = gql`
  mutation SaveLibraryCard($input: SaveLibraryCardInput!) {
    saveLibraryCard(input: $input) {
      success
      message
    }
  }
`;

// Mutation: Handle file uploads via presigned URLs
export const PUT_FILE_EVENT_MUTATION = gql`
  mutation PutFileEvent($input: PutFileEventInput!) {
    putFileEvent(input: $input) {
      presignedUrl
      message
    }
  }
`;

// Query: Fetch presigned URLs for uploading files
export const GET_PRESIGNED_URLS_QUERY = gql`
  query GetPresignedUrls($input: PresignedUrlsInput!) {
    getPresignedUrls(input: $input) {
      presignedUrls
    }
  }
`;

// input PresignedUrlsInput {
//   operationType: String!
//   entityType: String!
//   fileNames: [String!]!
// }

// Mutation: Initiate S3 Multipart Upload
export const INITIATE_MULTIPART_UPLOAD_MUTATION = gql`
  mutation InitiateVideoMultipartUpload($input: InitiateMultipartUploadInput!) {
    initiateVideoMultipartUpload(input: $input) {
      uploadId
      key
      bucket
    }
  }
`;

// Query: Get Presigned URL for Multipart Upload Part
export const GET_PRESIGNED_URL_FOR_PART_QUERY = gql`
  query GetPresignedUrlForPart($input: GetPresignedUrlForPartInput!) {
    getPresignedUrlForPart(input: $input) {
      presignedUrl
      partNumber
    }
  }
`;

// Mutation: Trigger Ad Agency Job (async via SQS or sync direct Lambda)
export const TRIGGER_AD_AGENCY_JOB_MUTATION = gql`
  mutation TriggerAdAgencyJob($input: AdAgencyJobInput!) {
    triggerAdAgencyJob(input: $input) {
      status
      jobId
      result
    }
  }
`;

// Mutation: Complete S3 Multipart Upload
export const COMPLETE_MULTIPART_UPLOAD_MUTATION = gql`
  mutation CompleteVideoMultipartUpload($input: CompleteMultipartUploadInput!) {
    completeVideoMultipartUpload(input: $input) {
      success
      location
      etag
      key
    }
  }
`;
